import React, { useEffect } from 'react';

import { navigate, withPage, useRouter } from '@sms/plasma-ui';
import app from '../../config/app.json';
import { booksApi } from "../../services";
import { booksFeatures } from '../../utils/booksFeatures';

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
const SUB_PATH: string = (window as any).plasma?.environment?.SUB_PATH ?? '/';
const PROCESSED_SUB_PATH = SUB_PATH.replace(/\/$/, '');

const BookSelectedPage: React.FC = () => {
  const { route } = useRouter('route');

  useEffect(() => {
    const bookId = route.params.bookId ?? "master";

    if (bookId === "master") {
      navigate(`${PROCESSED_SUB_PATH}/${app.code}/book/${bookId}/events`);
      return;
    }

    booksApi.getBook(Number(bookId)).then((res) => {
      var firstFeature = res.Features[0];
      
      if (firstFeature === booksFeatures.EVENTS) navigate(`${PROCESSED_SUB_PATH}/${app.code}/book/${bookId}/events`);
      if (firstFeature === booksFeatures.TASKS) navigate(`${PROCESSED_SUB_PATH}/${app.code}/book/${bookId}/tasks`);
      if (firstFeature === booksFeatures.PROCESSES) navigate(`${PROCESSED_SUB_PATH}/${app.code}/book/${bookId}/processes`);
      if (firstFeature === booksFeatures.DECISION_TABLES) navigate(`${PROCESSED_SUB_PATH}/${app.code}/book/${bookId}/decisionTables`);
      if (firstFeature === booksFeatures.RULES) navigate(`${PROCESSED_SUB_PATH}/${app.code}/book/${bookId}/rules`);
      if (firstFeature === booksFeatures.REPORTS) navigate(`${PROCESSED_SUB_PATH}/${app.code}/book/${bookId}/reports`);
      if (firstFeature === booksFeatures.BOARDS) navigate(`${PROCESSED_SUB_PATH}/${app.code}/book/${bookId}/boards`);
    });

  }, []);

  return <></>;
};

export default withPage(BookSelectedPage);
